/* @flow */

import React from 'react';
import { useTheme } from '@mui/styles';
import { MicOffIcon } from 'assets/images';
import PropTypes from 'prop-types';
import BaseIndicator from './BaseIndicator';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * React {@code Component} for showing an audio muted icon with a tooltip.
 *
 * @returns {Component}
 */
const AudioMutedIndicator = ({ tooltipPosition }) => {
  const theme = useTheme();

  return (
    <BaseIndicator
      icon={MicOffIcon}
      iconColor={theme.palette.iconError}
      iconId="mic-disabled"
      iconSize={12}
      id="audioMuted"
      tooltipKey="videothumbnail.mute"
      tooltipPosition={tooltipPosition}
    />
  );
};
AudioMutedIndicator.propTypes = {
  tooltipPosition: PropTypes.string
};
export default React.memo(withBoundary(AudioMutedIndicator));
